var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"workersGroupDetails"},[_c('mediaCenter',{attrs:{"tabIndex":"2"}}),_c('div',{staticClass:"contentBox"},[_c('div',{class:_vm.isMobile?'contentM':'content'},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.info.title))]),_c('div',{staticClass:"contents",domProps:{"innerHTML":_vm._s(_vm.info.content)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }